import ActionTypes from '../actions/types';
import { defaultState } from './defaultState';
import { setState, setObjectToState } from './helper';

const initialState = defaultState.search;

export default (state = initialState, action) => {

  switch(action.type) {
    case ActionTypes.SET_FILTERED_SPOTS:
      return setObjectToState(state, {
        availableFilteredSpots: action.availableFilteredSpots,
        allFilteredSpots: action.allFilteredSpots,
        isFilterApplied: true
      });
      
    case ActionTypes.SET_SEARCH_QUERY:
      return setState(state, action, 'query');

    case ActionTypes.SET_SEARCH_RESULT:
      return setState(state, action, 'result');

    case ActionTypes.SET_FILTER_OPTIONS:
      return setState(state, action, 'filterOptions');

    case ActionTypes.APPLY_FILTERS:
      return setState(state, action, 'appliedFilters');

    case ActionTypes.RESET_FILTERS:
      return setObjectToState(state, {
        appliedFilters: initialState.appliedFilters,
        isFilterApplied: false
      });

    case ActionTypes.SET_SEARCH_LOADING:
      return setState(state, {isLoading: true}, 'isLoading');

    case ActionTypes.RESET_SEARCH_LOADING:
      return setState(state, {isLoading: false}, 'isLoading');

    case ActionTypes.RESET_SEARCH:
      return initialState;

    default:
      return state;
  }

};



// WEBPACK FOOTER //
// ./src/reducers/searchReducer.js